import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect';
import {SIZES} from '@fupa/fupa-uikit';

const logoWidth = 160;
const logoHeight = 20;

const Container = styled.div`
  display: flex;
  width: ${logoWidth / 16}rem;
  height: ${logoHeight / 16}rem;
  justify-content: ${props => props.justify || 'left'};
  margin-bottom: ${SIZES['8']};

  a {
    display: inherit;
    width: inherit;
    height: inherit;
    justify-content: inherit;
  }
`;

const Logo = styled.img`
  align-self: center;
  max-width: ${logoWidth / 16}rem;
  max-height: ${logoHeight / 16}rem;
`;

const selectRegion = createSelector(
  state => state.session.district,
  district => {
    return {
      region: district?.region?.slug || '',
      district: district.slug || '',
    };
  }
);

const SiteSponsoring = ({className}) => {
  const {region, district} = useSelector(selectRegion);

  const defaultLink = 'https://www.sparkasse-aachen.de/pages/index.php';
  const specificDistrictLinks = {
    aachen: 'https://www.sparkasse-aachen.de/de/home.html',
    dueren: 'https://www.sparkasse-dueren.de/de/home.html',
    heinsberg: 'https://www.kreissparkasse-heinsberg.de/de/home.html',
  };

  const sponsoringPartner = {
    westrhein: [
      {
        imgPath: '/sponsoring/sparkasse_westrhein.svg',
        sponsor: 'Sparkasse',
        link: specificDistrictLinks[district] || defaultLink,
      },
    ],
    wuerttemberg: [
      {
        imgPath: '/sponsoring/wuerttemberg_vrbob.png',
        sponsor: 'VR Bank Bodensee-Oberschwaben',
        link: 'https://www.vrbank-rv-wgt.de',
      },
    ],
    zuerich: [
      {
        imgPath: '/sponsoring/zuerich_trb.png',
        sponsor: 'TRB Maurer AG',
        link: 'https://trb-maurer.ch/',
      },
      {
        imgPath: '/sponsoring/zuerich_ruha.png',
        sponsor: 'Ruha Baer Immobilien AG',
        link: 'https://ruhabaer.ch/',
        justify: 'right',
      },
    ],
  };

  if (sponsoringPartner[region]?.length) {
    return sponsoringPartner[region].map((partner, index) => {
      return (
        <Container key={index} justify={partner.justify} className={className}>
          <a target='_blank' href={partner.link}>
            <Logo src={partner.imgPath} width='auto' height='auto' alt={partner.sponsor} />
          </a>
        </Container>
      );
    });
  } else {
    return null;
  }
};

export {SiteSponsoring};
